<template>
<div @mouseenter="headerSelectmouseenter()" @mouseleave="headerSelectmouseleave()" class="headerSelectClass">
        <div>
            <div class="rightBoxA"></div>
            <div class="rightBox"></div>
            <ul class="accountSelectUl">
            <li
                @mousedown="mousedownFunc('myAccount', '1')"
                @mouseup="mouseupFunc('myAccount', '1')"
            >{{ $t('myConsole') }}
            </li>
            <li
                @mousedown="mousedownFunc('logOut', '1')"
                @mouseup="mouseupFunc('logOut', '1')"
                style="text-align:left;"
            >{{ $t('loginOut') }}</li>
            </ul>
        </div>
</div>
</template>

<script>
export default {
    data () {
        let protocol = window.location.protocol
        let splitLine = '//'
        let env = window.location.hostname
        let path = protocol + splitLine + env
        return {
            loginOut: '',
            env: env,
            base: path,
            path: '',
            frontPort: '8070'
        }
    },
    mounted () {
        let routes = this.$router.options.routes
        this.routes = routes
            .filter(
                item =>
                    item.hasOwnProperty('meta') &&
                    item.meta.hasOwnProperty('navObj')
            )
            .map(item => item.meta.navObj)
    },
    methods: {
        headerSelectmouseenter () {
            this.$store.state.isIndexSelectShow = true
        },
        headerSelectmouseleave () {
            this.$store.state.isIndexSelectShow = false
        },
        // header 导航事件
        headerNavMainFunc (path) {
            this.routes.forEach(item => {
                if (item.path === path) {
                    this.navRouterState(item)
                }
            })
        },
        loginOutFn () {
            localStorage.removeItem('token')
            this.$store.state.token = null
            sessionStorage.removeItem('registeredDetail')
            this.$store.state.registeredDetail = null
            this.$store.state.isSideBarShow = null
            sessionStorage.removeItem('isSideBarShow')
            this.$router.push({ name: 'userLogin' })
            this.$store.state.borderStyle = 'login'
            localStorage.setItem('clickState', 'login')
        },
        mouseupFunc (to, type, url) {
            if (to === 'logOut') {
                // this.$confirm(`${this.$t('message.prompt.common.content.logOut')} ${this.$t('message.prompt.common.title.continue')}`, this.$t('message.prompt.common.title.NWTeam'), {
                //     confirmButtonText: this.$t('message.prompt.common.title.tool.ok'),
                //     cancelButtonText: this.$t('userRoles.common.dialog.button.cancle'),
                //     type: 'warning'
                // }).then(() => {
                this.loginOutFn()
                // }).catch(() => {
                // })
                return
            }
            if (url && type === '0') {
                this.env === 'localhost' ? this.path = this.base + ':' + this.frontPort + '/documents/intro' : this.path = this.base + '/documents/intro'
                window.location.href = this.path
                // this.$router.push({ name: 'listApp' })
            } else if (url && type === '1') {
                if (to === 'bbsSty') {
                    window.location.href = url
                } else {
                    this.env === 'localhost' ? this.path = this.base + ':' + this.frontPort + '/documents/intro' : this.path = this.base + '/documents/intro'
                    window.location.href = this.path
                    // this.$router.push({ name: 'listApp' })
                }
            } else {
                if (type === '0') {
                } else {
                    this.env === 'localhost' ? this.path = this.base + ':' + this.frontPort : this.path = this.base
                    window.location.href = this.path
                    // console.log('in', )
                    // this.headerNavMainFunc('myAccount')
                }
            }
            this.$store.state.isFlagSpanClass = null
        },
        mousedownFunc (to, type, url) {
            if (to === 'logOut') {
                return
            }
            if (url && type === '0') {
            } else if (url && type === '1') {
            } else {
                if (type === '0') {
                } else {
                }
            }
        },
        consoleFunc () {
            this.$store.state.isIndexSelectShow = false
            this.$store.state.borderStyle = 'file'
            localStorage.setItem('clickState', 'file')
            this.env === 'localhost' ? this.path = this.base + ':' + this.frontPort + '/documents/intro' : this.path = this.base + '/documents/intro'
            window.location.href = this.path
            // this.$router.push({ name: 'listApp' })
        }
    },
    computed: {
        registeredDetail () {
            if (sessionStorage.registeredDetail === 'true' && localStorage.token !== undefined) {
                this.loginOut = this.$t('loginOut')
            } else {
                this.loginOut = this.$t('login')
            }
            return this.$store.state.registeredDetail
        }
    }
}
</script>
<style scoped>
/* 新增 */
*{
    margin: 0px;
    padding: 0px;
    list-style: none;
    font-size: 0px;
}
.rightBox {
    width: 0;
    height: 0;
    border-width: 0 5px 5px;
    border-style: solid;
    border-color: transparent transparent #fff;
    margin: 0px auto;
    top: 1px;
    position: relative;
    z-index: 1;
}
.rightBoxA {
    width: 0;
    height: 0;
    border-width: 0 6px 6px;
    border-style: solid;
    border-color: transparent transparent rgba(51, 51, 51, 0.2);
    margin: 0px auto;
    position: relative;
    top: 5.8px;
    left: -0.2px;
}
.accountSelectUl {
    padding-top: 6px;
    padding-bottom: 4px;
    border: solid 1px rgba(51, 51, 51, 0.2);
    border-radius: 5px;
    background-color: #ffffff;
}
.accountSelectUl li {
    height: 28px;
    text-align: center;
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 28px;
    letter-spacing: 0.7px;
    color: #333333;
    padding: 0px 10px;
}
.accountSelectUl li:hover {
    background-color: rgba(0, 224, 218, 0.1);
    cursor: pointer;
}
.accountSelectUl li:active {
    color: #00b5e2 !important;
    font-weight: 500 !important;
    box-sizing: border-box;
}
.accountSelect {
    position: absolute;
    top: 55px;
    left: -23px;
    z-index: 3;
}
/* 新增 */
.headerSelectHover:hover{
    cursor: pointer;
    padding-bottom: 2px;
    font-weight: 500!important;
    color: rgba(51, 51, 51, 0.5);
 }
.headerSelectClass{
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    position: absolute;
    right: 69px;
    top: -8px;
    z-index: 2;
}

.account {
  display: inline-block;
  width: 100%;
  height: 28px;
  opacity: 0.8;
  font-family: sans-serif;
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 28px;
  letter-spacing: 1.1px;
  text-align: left;
  color: var(--black);
  padding: 0px 11px;
}
.line{
  display: block;
  height: 1.2px;
  border: solid .8px #979797;
  margin: auto;
  display: none;
}
.account_copy {
  display: block;
  height: 28px;
  opacity: 0.8;
  font-family: sans-serif;
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 28px;
  letter-spacing: 1.1px;
  text-align: left;
  color: var(--black);
  padding: 0px 11px;
}
</style>
